module.exports = __webpack_public_path__ + "img/gb6564.prt.9ec9809d.jpg";